import { SearchOutlined } from '@ant-design/icons'
import { Input } from 'antd'
import _debounce from 'lodash/debounce'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { PAGE_PARAM, SEARCH_PARAM } from '../../../constants/query-params'
import useQueryParam from '../../../hooks/useQueryParam'
import useQueryParamSetter from '../../../hooks/useQueryParamSetter'

const SearchInput = ({ debounceTime = 500, searchParam = SEARCH_PARAM, ...props }) => {
    const search = useQueryParam(searchParam)
    const setQueryParam = useQueryParamSetter()
    const inputRef = useRef()

    const [searchValue, setSearchValue] = useState(search || '')

    const debounceSearchChange = useMemo(
        () =>
            _debounce(async searchValue => {
                setQueryParam({ [searchParam]: searchValue, [PAGE_PARAM]: undefined })
            }, debounceTime),
        [setQueryParam, searchParam, debounceTime],
    )

    const handleSearchChange = event => {
        setSearchValue(event.target.value)
        debounceSearchChange(event.target.value)
    }

    // Update local state when URL parameter changes
    useEffect(() => {
        setSearchValue(search || '')
    }, [search])

    return (
        <Input
            ref={inputRef}
            prefix={<SearchOutlined />}
            style={{ width: 320 }}
            allowClear
            value={searchValue}
            onChange={handleSearchChange}
            {...props}
        />
    )
}

export default SearchInput
